<template>
  <b-toast id="toast-add-cart-action-feedback" variant="light"
           :auto-hide-delay="10000" v-if="qtyForPhotoPackage">
    <div class="d-flex align-items-center py-2">
      <div class="text-center">
        <div :class="{'px-4': photosInCartCount < qtyForPhotoPackage}">
              <span v-if="photosInCartCount >= qtyForPhotoPackage">
                {{ $t('toast_cart_photo_package_feedback.text2', {price: priceForAllPhotos}) }}
              </span>
          <span v-else>
                {{ $t('toast_cart_photo_package_feedback.text1') }}
              </span>
        </div>
      </div>
    </div>
    <div class="row mt-2 justify-content-center" v-if="photosInCartCount >= qtyForPhotoPackage">
      <div class="col-6">
        <b-button variant="light" size="sm" block @click="$bvToast.hide('toast-add-cart-action-feedback')">
          {{ $t('toast_cart_photo_package_feedback.btn_cancel') }}
        </b-button>
      </div>
      <div class="col-6">
        <b-button variant="primary" block size="sm" @click="$emit('photo-package-activated')">
          {{ $t('toast_cart_photo_package_feedback.btn_ok') }}
        </b-button>
      </div>
    </div>
  </b-toast>
</template>

<script>
export default {
  name: "ToastAddCartFeedback",
  props: {
    photosInCartCount: {
      type: Number,
      required: true
    },
    qtyForPhotoPackage: {
      type: Number,
      required: true
    },
    priceForAllPhotos: {
      type: String,
      required: true
    },

  },
}
</script>


<style scoped>

</style>